module.exports = __webpack_public_path__ + "img/0-lg.ec4d35d8.jpg";